import React from 'react';
import * as PropTypes from 'prop-types';
import { Wrapper, Title, Label, Description } from './elements';

function ChaMeta04(props) {
  return (
    <Wrapper className={props.className}>
      <Title id={props.id} theme={props.theme}>
        {props.title}
      </Title>
      {props.icon ? (
        <Label
          color={props.theme === 'dark' ? 'rgba(255,255,255,0.7)' : '#546E7A'}
          icon={props.icon}
        >
          {props.children}
        </Label>
      ) : (
        <Description theme={props.theme}>{props.children}</Description>
      )}
    </Wrapper>
  );
}

ChaMeta04.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node,
  icon: PropTypes.string,
  theme: PropTypes.oneOf(['light', 'dark']),
};

export default ChaMeta04;
